if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.querySelector('product-info');

            this.preprocessHTML(productElement);
            HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);
            this.ensureQuickAddMediaVisible();

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      preprocessHTML(productElement) {
        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient')
            this.modalContent.classList.add(classApplied);
        });
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.simplifyQuickAddMedia(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      simplifyQuickAddMedia(productElement) {
        const mediaWrapper = productElement.querySelector('.product__media-wrapper');
        if (!mediaWrapper) return;

        const img =
          productElement.querySelector('.product__media-item.is-active img') ||
          productElement.querySelector('.product__media-item img');
        if (!img) return;

        const wrapper = document.createElement('div');
        wrapper.className = 'sfw-quick-add__media';
        const newImg = document.createElement('img');
        newImg.src = img.currentSrc || img.src;
        newImg.alt = img.alt || '';
        newImg.loading = 'eager';
        if (img.srcset) newImg.srcset = img.srcset;
        if (img.sizes) newImg.sizes = img.sizes;
        wrapper.appendChild(newImg);
        mediaWrapper.replaceChildren(wrapper);
      }

      ensureQuickAddMediaVisible() {
        const mediaImg = this.modalContent.querySelector('.sfw-quick-add__media img, .product__media-wrapper img');
        if (mediaImg?.offsetHeight > 0) return;

        const srcImg =
          this.modalContent.querySelector('.product__media-item.is-active img') ||
          this.modalContent.querySelector('.product__media-item img') ||
          mediaImg;
        const mediaWrapper = this.modalContent.querySelector('.product__media-wrapper');
        if (!srcImg?.src || !mediaWrapper) return;

        const wrapper = document.createElement('div');
        wrapper.className = 'sfw-quick-add__media';
        const newImg = document.createElement('img');
        newImg.src = srcImg.currentSrc || srcImg.src;
        newImg.alt = srcImg.alt || '';
        newImg.loading = 'eager';
        if (srcImg.srcset) newImg.srcset = srcImg.srcset;
        if (srcImg.sizes) newImg.sizes = srcImg.sizes;
        wrapper.appendChild(newImg);
        mediaWrapper.replaceChildren(wrapper);
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());

        productElement
          .querySelectorAll(
            '.main-page__breadcrumbs, share-button, .installment, .shopify-payment-button, shopify-payment-terms, [class*="gorgias"]'
          )
          .forEach((el) => el.remove());
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;

        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}
